<template>
    <div class="ship-card-main-style">
        <el-row class="ship-card-btn">
            <ship-flow-filter :mode-check="shipFlowType"/>
        </el-row>
        <el-card class="ship-crad-style">
            <el-row class="ship-card-btn">
                <ship-flow-panel :shipflow-mode="shipflowMode" :shipflow-panel-info="shipflowPanelInfo"/>
            </el-row>
            <el-row>
                <ship-flow-table :table-info.sync="shipflowTableData" :mode-check="shipFlowType" :pagination-detail="pagination.currentPage"/>
            </el-row>
            <el-row>
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                >
                </el-pagination>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import { eventBus } from '@/main'
import ShipFlowPanel from '@/components/ShipFlow/ShipFlowPanel.vue'
import ShipFlowTable from '@/components/ShipFlow/ShipFlowTable.vue'
import ShipFlowFilter from '@/components/ShipFlow/ShipFlowFilter.vue'
import fgApi from '@/services/fillgoods'

export default {
    name: 'ShipFlowBase',
    components: {
        ShipFlowPanel,
        ShipFlowTable,
        ShipFlowFilter
    },
    data () {
        return {
            shipFlowType: 1,
            searchText: null,
            // panel data
            shipflowMode: {
                mode: 1
            },
            shipflowPanelInfo: {
                allPickupTomorrow: 0,
                allPickupToday: 0,
                allConfirmed: 0,
                allWaitForPickup: 0,
                allPickedUp: 0
            },
            shipflowTableData: [],
            // pagination
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
        }
    },
    watch: {
        'shipflowMode.mode' (val) {
            this.$store.set('booking/shipFlowSelected', [])
            this.shipFlowType = val
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchShipFlow()
        }
    },
    created () {
        this.fetchShipFlow()
        eventBus.$on('shipflowReload', () => {
            this.fetchShipFlow()
        })
        eventBus.$on('bookingSearch', (val) => {
            this.searchText = val.search
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchShipFlow()
        })
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchShipFlow()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchShipFlow()
        },
        async fetchShipFlow () {
            this.$loading()
            let params = {
                ship_flow_type: this.shipFlowType,
                search_value: this.searchText,
                limit: this.pagination.limit,
                offset: this.pagination.offset
            }
            try {
                let res = await fgApi.courier.searchCourierBooking(params)
                if (res.success) {
                    let shipflowPanel = {
                        allPickupTomorrow: res.count.allPickupTomorrow,
                        allPickupToday: res.count.allPickupToday,
                        allConfirmed: res.count.allConfirmed,
                        allWaitForPickup: res.count.allWaitForPickup,
                        allPickedUp: res.count.allPickedUp
                    }
                    this.shipflowPanelInfo = shipflowPanel

                    let shipflowTable = []
                    for (let index in res.data) {
                        shipflowTable.push({ ...res.data[index] })
                    }
                    // console.log('shipflowTable', shipflowTable)
                    this.pagination.allPage = res.allPage
                    this.shipflowTableData = shipflowTable
                    console.log('table info :::', this.shipflowTableData)
                }
            } catch (error) {
                console.error(error)
            }
            this.$loading().close()
        }
    }

}
</script>

<style lang="scss" scoped>
    .ship-card-main-style{
        margin: 10px 10%;
        .ship-crad-style{
            padding: 40px;
        }
    }
    .ship-card-btn{
        padding-bottom: 25px;
    }
</style>
